import React, { useState } from 'react';
import GridCellWrapper from '../../../../components/grid-cell-wrapper/GridCellWrapper';
import { connect } from 'react-redux';
import Toolbar from '../../../../components/toolbar/Toolbar';
import DropDown from '../../../../components/dropdown/Dropdown';
import Button from '../../../../components/button/Button';
import {
  getMondayOfTheWeek,
  getSaturdayOfTheWeek,
} from '../../../../utils/time';
import { utcIsoDateToLocaleDate } from '../../../../utils/date';
import Table from '../../../../components/table/Table';

const Transportauftraege = () => {
  const [columnConfig, setColumnConfig] = useState(initColumnConfig());
  const [data, setData] = useState(initData());
  const [selectedRow, setSelectedRow] = useState<number | undefined>(undefined);
  const [zeitabschnitt, setZeitabschnitt] = useState('');

  const tomorrow = new Date(Date.now());
  tomorrow.setDate(tomorrow.getDate() + 1);
  const heute = utcIsoDateToLocaleDate(new Date(Date.now()));
  const morgen = utcIsoDateToLocaleDate(tomorrow);
  const montag = utcIsoDateToLocaleDate(getMondayOfTheWeek());
  const samstag = utcIsoDateToLocaleDate(getSaturdayOfTheWeek());

  return (
    <GridCellWrapper
      classes='transportauftraege'
      label='Transportaufträge'
      saveUserAnsicht={() => {
        null;
      }}
    >
      <Toolbar>
        <DropDown icon='fas fa-print fa-lg'>
          <span>CMR</span>
          <span>Speditionsauftrag</span>
          <span>Transportauftrag</span>
          <span>Lademittelschein</span>
          <span>Lieferschein</span>
          <span>Label</span>
          <span>Gefahrgutdokument</span>
        </DropDown>
        <Button tooltip={'Einstellungen'} key={0} classes={'iconButton'}>
          <i className='fas fa-cogs fa-lg' />
        </Button>
        <Button onClickHandler={() => setZeitabschnitt(heute + ' - ' + heute)}>
          heute
        </Button>
        <Button onClickHandler={() => setZeitabschnitt(heute + ' - ' + morgen)}>
          morgen
        </Button>
        <Button
          onClickHandler={() => setZeitabschnitt(montag + ' - ' + samstag)}
        >
          Werktagwoche
        </Button>
        <label>{zeitabschnitt}</label>
      </Toolbar>
      <Table
        setTableConfig={setColumnConfig}
        tableConfig={columnConfig}
        data={data}
        edit={false}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
      />
    </GridCellWrapper>
  );
};

const initData = () => {
  return [
    {
      id: null,
      beladedatum: '',
      versender: '',
      versenderPlz: '',
      versenderOrt: '',
      empfaenger: '',
      empfaengerPlz: '',
      empfaengerOrt: '',
      artikel: '',
      lademeter: '',
      services: '',
    },
  ];
};

const initColumnConfig = () => {
  return [
    {
      id: 1,
      columnName: 'Beladedatum',
      attributName: 'beladedatum',
      valueType: 'string',
    },
    {
      id: 2,
      columnName: 'Versender',
      attributName: 'versender',
      valueType: 'string',
    },
    {
      id: 3,
      columnName: 'V-PLZ',
      attributName: 'versenderPlz',
      valueType: 'number',
    },
    {
      id: 4,
      columnName: 'V-Ort',
      attributName: 'versenderOrt',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'Empfänger',
      attributName: 'empfaenger',
      valueType: 'string',
    },
    {
      id: 6,
      columnName: 'E-PLZ',
      attributName: 'empfaengerPlz',
      valueType: 'number',
    },
    {
      id: 7,
      columnName: 'E-Ort',
      attributName: 'empfaengerOrt',
      valueType: 'string',
    },
    {
      id: 8,
      columnName: 'Artikel',
      attributName: 'artikel',
      valueType: 'string',
    },
    {
      id: 9,
      columnName: 'Lademeter',
      attributName: 'lademeter',
      valueType: 'float',
    },
    {
      id: 10,
      columnName: 'Services',
      attributName: 'services',
      valueType: 'string',
    },
  ];
};

const mapStateToProps = (state: {
  Auftragserfassung: { resetToggle: boolean };
}) => ({
  resetToggle: state.Auftragserfassung.resetToggle,
});

export default connect(mapStateToProps, {})(Transportauftraege);
